import { useShowContext } from 'framework/show';
import BaseTimelineRecordLayout from 'domain/shared/timeline/layout/BaseTimelineRecordLayout';
import PresaleRequestFields from 'domain/sales/opportunity/presale/request/PresaleRequestTimelineRecordLayout/PresaleRequestFields';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import { Collapsible } from 'framework/ui/field';
import RedmineIssueField from 'infrastructure/integrations/redmine/RedmineIssueField';
import { EditTimelineRecordButton } from 'domain/shared/timeline/button';
import { PinTimelineButton } from 'domain/shared/timeline';
import { useOpportunityId } from 'domain/shared/opportunity';
import { UPDATE_PRESALE_REQUEST } from 'domain/sales/opportunity/opportunityService';
import PresaleStatusBadge from 'domain/sales/opportunity/presale/request/shared/field/PresaleStatusBadge';
import { useListContext } from 'framework/list';
import { TimelineContextData } from 'framework/ui/timeline';
import { Box, Typography } from '@mui/material';
import { timelineAdditionalSx } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/baseTimelineRecordSx';

const PresaleRequestTimelineRecordLayout = ({ onEdit, isPinned, ...props }: any) => {
  const opportunityId = useOpportunityId();
  const { data } = useShowContext();
  const timelineId = data.getValueBySource('timelineId');
  const { updateInList, pinTimelineAction }: TimelineContextData = useListContext();

  const buttons = [<EditTimelineRecordButton onEdit={onEdit} permissionToCheck={UPDATE_PRESALE_REQUEST} />];

  return (
    <BaseTimelineRecordLayout
      fields={
        <Collapsible>
          <PresaleRequestFields />
        </Collapsible>
      }
      entity={data}
      timelineType={TimelineType.FEEDBACK}
      buttons={buttons}
      actions={[
        <PinTimelineButton
          pinStatus={isPinned}
          pinMethod={async () => {
            const response = await pinTimelineAction!(opportunityId, timelineId, !isPinned);
            updateInList!(response?.id, response);
          }}
        />,
      ]}
      timelineFooter={() => (
        <Box display="flex" sx={timelineAdditionalSx}>
          <Typography component="span" variant="inherit">
            Redmine ticket:&nbsp;
          </Typography>
          <RedmineIssueField source="redmineTicketId" />
          <PresaleStatusBadge statusSource="requestStatus" />
        </Box>
      )}
      {...props}
    />
  );
};

export default PresaleRequestTimelineRecordLayout;
